import { render, staticRenderFns } from "./FieldGroupHeading.vue?vue&type=template&id=156e230f&scoped=true&"
import script from "./FieldGroupHeading.vue?vue&type=script&lang=js&"
export * from "./FieldGroupHeading.vue?vue&type=script&lang=js&"
import style0 from "./FieldGroupHeading.vue?vue&type=style&index=0&id=156e230f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e230f",
  null
  
)

export default component.exports